<template>
  <div>
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-row :gutter="24">
          <a-col :lg="6" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="单据日期">
              <j-date v-decorator="['operTime', validatorRules.operTime]" :show-time="true" :disabled="!rowCanEdit"/>
            </a-form-item>
          </a-col>
          <a-col :lg="6" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="单据编号">
              <a-input placeholder="请输入单据编号" v-decorator.trim="['number', validatorRules.number]" :disabled="!rowCanEdit" />
            </a-form-item>
          </a-col>
          <a-col :lg="6" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="关联申领单">
              <a-input-search placeholder="请选择关联申领单" v-decorator="['linkApply']" @search="onSearchLinkApply" :readOnly="true" :disabled="!rowCanEdit"/>
            </a-form-item>
          </a-col>
        </a-row>
        <j-editable-table
          :ref="refKeys[0]"
          :loading="materialTable.loading"
          :columns="materialTable.columns"
          :dataSource="materialTable.dataSource"
          :minWidth="1100"
          :maxHeight="300"
          :rowNumber="true"
          :rowSelection="rowCanEdit"
          :actionButton="rowCanEdit"
          :dragSortAndNumber="rowCanEdit"
          @valueChange="onValueChange"
          @added="onAdded"
          @deleted="onDeleted">
          <template #buttonAfter>
            <a-row v-if="rowCanEdit" :gutter="24" style="float:left;">
              <a-col v-if="scanStatus" :md="6" :sm="24">
                <a-button @click="scanEnter">扫码录入</a-button>
              </a-col>
              <a-col v-if="!scanStatus" :md="16" :sm="24" style="padding: 0 8px 0 12px">
                <a-input placeholder="请扫描商品条码并回车" v-model="scanBarCode" @pressEnter="scanPressEnter" ref="scanBarCode"/>
              </a-col>
              <a-col v-if="!scanStatus" :md="6" :sm="24" style="padding: 0px 12px 0 0">
                <a-button @click="stopScan">收起扫码</a-button>
              </a-col>
            </a-row>
          </template>
          <template #depotBatchSet>
            <a-icon type="down" @click="handleBatchSetDepot" />
          </template>
        </j-editable-table>
        <a-row class="form-row" :gutter="24" style="margin-top: 8px;">
          <a-col :lg="24" :md="24" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="{xs: { span: 24 },sm: { span: 24 }}" label="">
              <a-textarea :rows="1" placeholder="请输入备注" v-decorator="['remark']" :disabled="!rowCanEdit" />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-spin>
    <div style="text-align: right; margin-top: 16px;">
      <a-button v-if="formMode === 'view'" @click="handleCancel">返回</a-button>
      <template v-else>
        <a-button @click="handleCancel">取消</a-button>
        <a-button v-if="checkFlag && isCanCheck" :loading="confirmLoading" @click="handleOkAndCheck">保存并审核</a-button>
        <a-button v-if="!checkFlag" type="primary" :loading="confirmLoading" @click="handleWorkflow()">提交流程</a-button>
        <a-button type="primary" :loading="confirmLoading" @click="handleOk">保存</a-button>
      </template>
    </div>
    <depot-modal ref="depotModalForm" @ok="depotModalFormOk"></depot-modal>
    <batch-set-depot ref="batchSetDepotModalForm" @ok="batchSetDepotModalFormOk"></batch-set-depot>
    <workflow-iframe ref="modalWorkflow" @ok="workflowModalFormOk"></workflow-iframe>
    <link-bill-list v-if="rowCanEdit" ref="linkBillList" @ok="linkBillListOk"></link-bill-list>
  </div>
</template>

<script>
  import pick from 'lodash.pick'
  import { getAction, postAction } from '@/api/manage'
  import { getCurrentSystemConfig } from '@/api/api'
  import { getCheckFlag } from '@/utils/util'
  import JDate from '@/components/jeecg/JDate'
  import DepotModal from '../../system/modules/DepotModal'
  import BatchSetDepot from '../../bill/dialog/BatchSetDepot'
  import LinkBillList from '../../bill/dialog/LinkBillList'
  import WorkflowIframe from '@/components/tools/WorkflowIframe'
  import { FormTypes } from '@/utils/JEditableTableUtil'
  import { JEditableTableMixin } from '@/mixins/JEditableTableMixin'
  import { BillModalMixin } from '@/views/bill/mixins/BillModalMixin'

  export default {
    name: "InnerOutModal",
    mixins: [JEditableTableMixin, BillModalMixin],
    components: { JDate, DepotModal, BatchSetDepot, WorkflowIframe, LinkBillList },
    props: {
      formMode: { type: String, default: 'add' }
    },
    data () {
      return {
        width: '1400px',
        visible: false,
        confirmLoading: false,
        rowCanEdit: true,
        isCanCheck: true,
        checkFlag: true,
        action: '',
        model: {},
        labelCol: { xs: { span: 24 }, sm: { span: 8 } },
        wrapperCol: { xs: { span: 24 }, sm: { span: 16 } },
        refKeys: ['materialDataTable'],
        prefixNo: 'NCKD',
        addDefaultRowNum: 1,
        scanStatus: true,
        scanBarCode: '',
        billStatus: '0',
        materialTable: {
          loading: false,
          dataSource: [],
          columns: [
            { title: '仓库名称', key: 'depotId', width: '8%', type: FormTypes.select, placeholder: '请选择${title}',
              options: [], allowSearch: true, validateRules: [{ required: true, message: '${title}不能为空' }]
            },
            { title: '条码', key: 'barCode', width: '12%', type: FormTypes.popupJsh, kind: 'material', multi: true, enableAsset: true,
              validateRules: [{ required: true, message: '${title}不能为空' }]
            },
            { title: '名称', key: 'name', width: '9%', type: FormTypes.normal },
            { title: '规格', key: 'standard', width: '7%', type: FormTypes.normal },
            { title: '型号', key: 'model', width: '7%', type: FormTypes.normal },
            { title: '单位', key: 'unit', width: '4%', type: FormTypes.normal },
            { title: '库存', key: 'stock', width: '5%', type: FormTypes.normal },
            { title: '数量', key: 'operNumber', width: '6%', type: FormTypes.inputNumber,
              validateRules: [{ required: true, message: '${title}不能为空' }]
            },
            { title: '单价', key: 'unitPrice', width: '6%', type: FormTypes.inputNumber },
            { title: '金额', key: 'allPrice', width: '6%', type: FormTypes.inputNumber },
            { title: '备注', key: 'remark', width: '6%', type: FormTypes.input }
          ]
        },
        validatorRules: {
          operTime: { rules: [{ required: true, message: '请输入单据日期!' }] },
          number: { rules: [{ required: true, message: '请输入单据编号!' }] }
        },
        url: {
          add: '/depotHead/addDepotHeadAndDetail',
          edit: '/depotHead/updateDepotHeadAndDetail',
          detailList: '/depotItem/getDetailList'
        }
      }
    },
    methods: {
      detail(record) {
        this.action = 'view'
        this.edit(record)
      },
      editAfter() {
        this.billStatus = '0'
        this.rowCanEdit = this.formMode !== 'view'
        if (this.action === 'add') {
          this.addInit(this.prefixNo)
        } else {
          this.model.operTime = this.model.operTimeStr
          this.$nextTick(() => {
            this.form.setFieldsValue(pick(this.model, 'operTime', 'number', 'linkApply', 'remark'))
          })
          if (this.model.id) {
            let params = { headerId: this.model.id, mpList: '', linkType: 'basic' }
            this.requestSubTableData(this.url.detailList, params, this.materialTable)
          }
        }
        if (this.action === 'copyAdd') {
          this.model.id = ''
          this.copyAddInit(this.prefixNo)
        }
        this.initDepot()
        this.initSystemConfig()
      },
      classifyIntoFormData(allValues) {
        let totalPrice = 0
        let billMain = Object.assign(this.model, allValues.formValue)
        let detailArr = allValues.tablesValue[0].values
        billMain.type = '出库'
        billMain.subType = '资产出库'
        for (let item of detailArr) {
          totalPrice += item.allPrice - 0
        }
        billMain.totalPrice = totalPrice
        if (this.model.id) {
          billMain.id = this.model.id
        }
        billMain.status = this.billStatus
        return { info: JSON.stringify(billMain), rows: JSON.stringify(detailArr) }
      },
      handleCancel() {
        this.$emit('cancel')
        this.close()
      },
      handleOkAndCheck() {
        this.billStatus = '1'
        this.handleOk()
      },
      handleWorkflow() {
        this.$refs.modalWorkflow.show(this.model, '', this.model.number, 1, 320)
        this.$refs.modalWorkflow.title = "发起流程"
      },
      depotModalFormOk() {
        this.initDepot()
      },
      addDepot() {
        this.$refs.depotModalForm.add()
      },
      initSystemConfig() {
        getCurrentSystemConfig().then((res) => {
          if (res.code === 200 && res.data) {
            let multiBillType = res.data.multiBillType
            let multiLevelApprovalFlag = res.data.multiLevelApprovalFlag
            this.checkFlag = getCheckFlag(multiBillType, multiLevelApprovalFlag, this.prefixNo)
          }
        })
      },
      onSearchLinkApply() {
        this.$refs.linkBillList.purchaseShow('其它', '资产申领', '客户', "1,3")
        this.$refs.linkBillList.title = "请选择资产申领单"
      },
      linkBillListOk(selectBillDetailRows, linkNumber) {
        if(selectBillDetailRows && selectBillDetailRows.length>0) {
          let listEx = []
          for(let j=0; j<selectBillDetailRows.length; j++) {
            let info = selectBillDetailRows[j];
            info.operNumber = info.preNumber - info.finishNumber
            info.linkId = info.id
            //带出价格：优先申领单已录单价，空则用商品采购价
            if(info.unitPrice == null || info.unitPrice === '') {
              info.unitPrice = (info.purchaseDecimal || 0) - 0
            }
            info.allPrice = (info.operNumber * info.unitPrice).toFixed(2) - 0
            if(info.operNumber>0) {
              listEx.push(info)
            }
          }
          this.materialTable.dataSource = listEx
          this.$nextTick(() => {
            this.form.setFieldsValue({'linkApply': linkNumber})
          })
        }
      },
      workflowModalFormOk() {
        this.close()
      }
    }
  }
</script>